import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* lockRoomSaga() {
  yield call(SignalingSocket.send, {
    event: 'lockRoom',
  });
}
